import React, { Component } from 'react';
import { connect} from 'react-redux';
import {
    withRouter
} from 'react-router-dom';

// import components.

import { BigTitle } from './title';
import { LpWizardMain } from './main';
import Preview from './preview';
import LpSideMenu from './side_menu';
import RepriseWizard from './reprise_wizard';

import lpApp from '../app/lp_app';
import { setAppState, LP_STATE_WIZARD } from '../redux/actions/app_state';



class WizardContainer extends Component {

    constructor(props) {
      super(props);
      // TODO: recheck the aside class, when we have second step is always comes with creation product
      lpApp.callbacks.setupInitialCallbacks();
      lpApp.main(
        this.props.match.params.name,
        this.props.match.params.id ? this.props.match.params.id : ''
      );
    }


    componentWillMount() {
      if(lpApp.getState().contract.fullWidth){
        document.body.classList.add("full-wizard");
      }
      this.props.setWizardAppState();
    }

    render() {
        const {
            reprise_wizard,
            contractName,
            appState,
            fullWidth
        } = this.props;

        let reprise = reprise_wizard;
        let not_reprise = !reprise;

        return (<div>
            <BigTitle text={contractName}/>
            <div className="wizard-container" id="wizard-container">
                {(reprise) ? <RepriseWizard /> : ""}
                <div className="content-holder">
                    {/*{!reprise && ((appState == 0) || (appState == 1) || (appState == 3) || (appState == 4)) ?*/}
                    {!reprise ?
                        <div className="wizard">
                            <LpWizardMain
                              sectionId={parseInt(this.props.match.params.sectionId, 10)}
                            />
                        </div>:
                        <div>
                        </div>}
                        {not_reprise && !fullWidth && ((appState == 0) || (appState == 1) || (appState == 3)) ?
                        <div className={lpApp.isPayed ? "forcing-aside" : "aside"}>
                            {(lpApp.isPayed && (appState != 2))
                              ? <LpSideMenu/>
                              : (
                                (lpApp.env.client_zone.width >= 765) && ((appState == 0) || (appState == 1) || (appState == 3) && !this.props.wizard_loading)
                                  ? <Preview /> : <div></div>
                              )}
                        </div> :
                        <div></div>}
                </div>
            </div>
        </div>)
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    reprise_wizard: state.contract.reprise_wizard,
    contractName: state.contract.name,
    appState: state.appstate,
    fullWidth: state.contract.fullWidth,
    wizard_loading: state.loading_details.wizard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setWizardAppState: () => dispatch(setAppState(LP_STATE_WIZARD))
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardContainer));




// WEBPACK FOOTER //
// ./src/components/wizard_container.js